import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";
import SearchSelect from "../../../../../components/private/searchselect";
import Pagination from "../../../../../components/private/pagination";

const SeguimientoGeneralDos = () => {

  const navigate = useNavigate();
  const { authFetch } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [programOptions, setProgramOptions] = useState([]);

  // =====================
  // FILTROS
  // =====================

  const [filtroPrograma, setFiltroPrograma] = useState("");
  const [filtroContratante, setFiltroContratante] = useState("");
  const [filtroAnio, setFiltroAnio] = useState("");
  const [filtroMes, setFiltroMes] = useState("");
  const [filtroGrupo, setFiltroGrupo] = useState("");

  // =====================
  // PAGINACIÓN
  // =====================

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =====================
  // MESES
  // =====================

  const meses = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  };

  // =====================
  // PARSEAR FECHA
  // =====================

  const parsearMesAnio = (fecha) => {

    if (!fecha) return null;

    const [anio, mes, dia] = fecha
      .split("-")
      .map(Number);

    return new Date(
      anio,
      mes - 1,
      dia || 1
    );

  };

  // =====================
  // CARGAR DATOS
  // =====================

  useEffect(() => {

    const loadSeguimientos = async () => {

      setLoading(true);

      try {

        const res = await authFetch(
          ENDPOINTS.get_seguimiento_dos_general
        );

        if (res.success) {

          const rows = res.data || [];

          setData(rows);

          // =====================
          // PROGRAMAS
          // =====================

          const uniquePrograms = [

            ...new Map(

              rows.map(item => [

                item.programa,

                {
                  value: item.programa,
                  label: item.programa
                }

              ])

            ).values()

          ];

          setProgramOptions(uniquePrograms);

        } else {

          setData([]);

          setProgramOptions([]);

        }

      } catch (error) {

        console.error(error);

        setData([]);

        setProgramOptions([]);

      }

      setLoading(false);

    };

    loadSeguimientos();

  }, [authFetch]);

  // =====================
  // FILTROS
  // =====================

  const filteredData = data.filter((item) => {

    const matchesPrograma =

      filtroPrograma === "" ||

      item.programa === filtroPrograma;

    const matchesContratante =

      filtroContratante === "" ||

      item.contratante
        ?.toLowerCase()
        .includes(
          filtroContratante.toLowerCase()
        );

    const fecha = parsearMesAnio(item.mes_año);

    const matchesAnio =

      filtroAnio === "" ||

      (
        fecha &&
        fecha.getFullYear()
          .toString()
          .includes(filtroAnio)
      );

    const matchesMes =

      filtroMes === "" ||

      (
        fecha &&
        String(fecha.getMonth() + 1) ===
          String(filtroMes)
      );

    const matchesGrupo =

      filtroGrupo === "" ||

      String(item.grupo) ===
        String(filtroGrupo);

    return (

      matchesPrograma &&
      matchesContratante &&
      matchesAnio &&
      matchesMes &&
      matchesGrupo

    );

  });

  // =====================
  // PAGINACIÓN
  // =====================

  const totalPages = Math.ceil(
    filteredData.length /
    recordsPerPage
  );

  const currentData = filteredData.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {

    if (
      page >= 1 &&
      page <= totalPages
    ) {

      setCurrentPage(page);

    }

  };

  // =====================
  // LOADING
  // =====================

  if (loading) {

    return (

      <div className="text-center mt-4">

        Cargando...

      </div>

    );

  }

  // =====================
  // RENDER
  // =====================

  return (

    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>
          Seguimiento Técnico General por Datos Agrupados
        </h3>

        <button
          className="btn btn-outline-pink"
          onClick={() =>
            navigate(
              "/session/mod_administrativa/informacion_general/informacion_general"
            )
          }
        >

          <i className="bi bi-arrow-left me-1"></i>

          Volver

        </button>

      </div>

      {/* FILTROS */}

      <div className="row mb-4">

        {/* PROGRAMA */}

        <div className="col-md-3">

          <label className="m-1">
            Programa
          </label>

          <SearchSelect

            options={[
              {
                value: "",
                label: "Todos"
              },

              ...programOptions

            ]}

            value={filtroPrograma}

            onChange={(val) => {

              setFiltroPrograma(val);

              setCurrentPage(1);

            }}

            placeholder="Buscar programa..."

          />

        </div>

        {/* CONTRATANTE */}

        <div className="col-md-2">

          <label className="m-1">
            Contratante
          </label>

          <input
            type="text"
            className="form-control"
            value={filtroContratante}
            onChange={(e) => {

              setFiltroContratante(
                e.target.value
              );

              setCurrentPage(1);

            }}
          />

        </div>

        {/* AÑO */}

        <div className="col-md-2">

          <label className="m-1">
            Año
          </label>

          <input
            type="text"
            className="form-control"
            maxLength={4}
            value={filtroAnio}
            onChange={(e) => {

              setFiltroAnio(
                e.target.value
              );

              setCurrentPage(1);

            }}
          />

        </div>

        {/* MES */}

        <div className="col-md-2">

          <label className="m-1">
            Mes
          </label>

          <select
            className="form-select"
            value={filtroMes}
            onChange={(e) => {

              setFiltroMes(
                e.target.value
              );

              setCurrentPage(1);

            }}
          >

            <option value="">
              Todos
            </option>

            <option value="1">Enero</option>
            <option value="2">Febrero</option>
            <option value="3">Marzo</option>
            <option value="4">Abril</option>
            <option value="5">Mayo</option>
            <option value="6">Junio</option>
            <option value="7">Julio</option>
            <option value="8">Agosto</option>
            <option value="9">Septiembre</option>
            <option value="10">Octubre</option>
            <option value="11">Noviembre</option>
            <option value="12">Diciembre</option>

          </select>

        </div>

        {/* GRUPO */}

        <div className="col-md-3">

          <label className="m-1">
            Grupo
          </label>

          <select
            className="form-select"
            value={filtroGrupo}
            onChange={(e) => {

              setFiltroGrupo(
                e.target.value
              );

              setCurrentPage(1);

            }}
          >

            <option value="">Todos</option>
            <option value="1">Grupo 1</option>
            <option value="2">Grupo 2</option>
            <option value="3">Grupo 3</option>
            <option value="4">Grupo 4</option>
            <option value="5">Grupo 5</option>
            <option value="6">Grupo 6</option>

          </select>

        </div>

      </div>

      {/* TABLA */}

      <div className="table-responsive">

        <table className="table table-bordered table-hover">

          <thead className="table-secondary">

            <tr>

              <th>Programa</th>
              <th>Contratante</th>
              <th>Contrato</th>
              <th>Grupo</th>
              <th>Seguimiento</th>
              <th>Mes</th>
              <th>Año</th>
              <th>Acción</th>

            </tr>

          </thead>

          <tbody>

            {currentData.length > 0 ? (

              currentData.map((item) => {

                const fecha =
                  parsearMesAnio(
                    item.mes_año
                  );

                return (

                  <tr key={item.id}>

                    <td>{item.programa}</td>
                    <td>{item.contratante}</td>
                    <td>{item.contrato_convenio}</td>
                    <td>Grupo {item.grupo}</td>
                    <td>{item.seguimiento}</td>
                    <td> {fecha ? meses[fecha.getMonth() + 1] : ""}</td>
                    <td>{fecha ? fecha.getFullYear() : ""}</td>
                    <td>
                      <button className="btn btn-info btn-sm" onClick={() => {navigate(`/session/mod_administrativa/informacion_general/seguimiento_tecnico_dos/seguimiento_dos/${item.id_informacion_general}?seguimiento=${item.id}`);}}>
                        <i className="bi bi-pencil-square me-1"></i>
                        Abrir
                      </button>
                    </td>

                  </tr>

                );

              })

            ) : (

              <tr>

                <td colSpan="8" className="text-center">No existen seguimientos registrados</td>

              </tr>

            )}

          </tbody>

        </table>

      </div>

      {/* PAGINACIÓN */}

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={goToPage}
      />

    </div>

  );

};

export default SeguimientoGeneralDos;